module.exports = __webpack_public_path__ + "img/invoice_canceled.af158fb1.svg";